import { domainToRegex } from "./urlPatternConversion";

/** The configured base URL, trimmed, or the connector's default when unset. */
export function resolveBaseUrl(
  baseUrl: string | undefined,
  defaultBaseUrl: string
): string {
  return baseUrl?.trim() || defaultBaseUrl;
}

/**
 * URL pattern scoping proxy credential injection to the resolved base URL,
 * including its path prefix (e.g. `/v1`) so the credential isn't broadcast to
 * unrelated paths on the same host.
 */
export function baseUrlPattern(
  baseUrl: string | undefined,
  defaultBaseUrl: string
): string {
  return domainToRegex(resolveBaseUrl(baseUrl, defaultBaseUrl));
}

/** The resolved base URL joined with `path`, with any trailing slash trimmed. */
export function baseUrlEndpoint(
  baseUrl: string | undefined,
  defaultBaseUrl: string,
  path: string
): string {
  return `${resolveBaseUrl(baseUrl, defaultBaseUrl).replace(/\/$/, "")}${path}`;
}
